import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import WorksheetTable from 'components/worksheet/worksheet_table';
import BannerNoticeIndex from 'components/banner_notice/banner_notice_index';
import PageTitle from 'components/common/page_title';
import { ExerciseUI } from '@seedlang/state';
import autobind from 'autobind-decorator';
import { UserWorksheetStore } from '@seedlang/stores';

const Wrapper = styled.div`
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
`;

@observer
class PodcastWorksheetIndex extends React.Component {

  @autobind getItemRoute(item) {
    return {
      name: 'podcast.show',
      params: {
        worksheetId: item.id,
      },
    };
  }

  @autobind onToggleCompleted(item) {
    const newValue = !item.overrideCompleted;
    item.set('overrideCompleted', newValue);
    UserWorksheetStore.updateByWorksheetId({
      ids: { worksheetId: item.id },
      data: { overrideCompleted: newValue },
    });
  }

  render() {
    return (
      <Wrapper>
        <PageTitle>Podcast</PageTitle>
        <BannerNoticeIndex
          route='podcast.index'
        />
        <WorksheetTable
          showFilters
          headerTitle='Episode'
          defaultWorksheetFilter={{podcast_episode_id: true}}
          store={ExerciseUI.worksheetStore}
          getItemRoute={this.getItemRoute}
          onToggleCompleted={this.onToggleCompleted}
          {...this.props}
        />
      </Wrapper>
    );
  }
}

export default ErrorBoundary(PodcastWorksheetIndex);
